import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCurrency } from "../context/CurrencyContext";
import Reveal from "./Reveal";

export const pushRecentlyViewed = (id) => {
  try {
    const prev = JSON.parse(localStorage.getItem("atw_recent") || "[]");
    const next = [id, ...prev.filter((x) => x !== id)].slice(0, 10);
    localStorage.setItem("atw_recent", JSON.stringify(next));
  } catch {
    /* ignore */
  }
};

export default function RecentlyViewed({ excludeId = null }) {
  const { format } = useCurrency();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let ids = [];
    try {
      ids = JSON.parse(localStorage.getItem("atw_recent") || "[]");
    } catch {
      ids = [];
    }
    ids = ids.filter((x) => x !== excludeId);
    if (!ids.length) return;
    api
      .get("/products")
      .then((r) => {
        const byId = Object.fromEntries(r.data.map((p) => [p.id, p]));
        setItems(ids.map((id) => byId[id]).filter(Boolean).slice(0, 6));
      })
      .catch(() => {});
  }, [excludeId]);

  if (items.length < 2) return null;

  return (
    <section data-testid="recently-viewed" className="relative py-16 md:py-20 px-6 lg:px-12 bg-obsidian text-ivory">
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <p className="text-[10px] tracking-[0.5em] uppercase gold-text mb-6">Pick up where you left off</p>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mb-8">Recently viewed</h2>
        </Reveal>
        <div className="flex gap-5 overflow-x-auto pb-4 -mx-6 px-6 lg:mx-0 lg:px-0 scrollbar-none">
          {items.map((p) => (
            <Link
              key={p.id}
              to={`/product/${p.id}`}
              data-testid={`recent-item-${p.id}`}
              className="group shrink-0 w-40 md:w-48"
            >
              <div className="aspect-[3/4] overflow-hidden bg-coal border border-gold/10">
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <p className="mt-3 text-[9px] tracking-[0.3em] uppercase text-ivory/40">{p.category}</p>
              <p className="font-serif text-sm mt-1 leading-snug group-hover:text-gold-light transition-colors">{p.name}</p>
              <p className="text-gold-light/80 text-sm mt-1">{format(p.price)}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
